<div class="container">
  <div class="row">
    <div class="col-12">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a appHref='/'>{{'HOME' | translate | htmlToText}}</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{'TITOLO_INSTALLATORI' | translate | htmlToText}}</li>
        </ol>
      </nav>
    </div>
  </div>
</div>
<div class="container mb-5">
  <div class="row titolo-pagina">
    <div class="col-12">
      <h1 class="">
        {{'TITOLO_INSTALLATORI' | translate | htmlToText}}
      </h1>
      <p>{{'SOTTOTITOLO_INSTALLATORI' | translate | htmlToText}} </p>
    </div>
  </div>
</div>
<!-- RICERCA PER LUOGO (si può anche per nome?) -->
<div class="container mb-3">
  <div class="row">

    <div class="col-12 col-md-4">
      <div class="form-newsletter">
        <div class="input-group mb-3">
          <input type="text" class="form-control" placeholder="{{'CERCA_PER_LUOGO' | translate | htmlToText}}" [(ngModel)]="ricercaLuogo" name="ricercaLuogo">
          <div class="input-group-append">
            <button class="btn btn-stem" type="button" [disabled]="!ricercaLuogo" (click)="cercaLuogo()"><i class="fas fa-search"></i></button>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
<!-- //RICERCA PER LUOGO (si può anche per nome?) -->
<!-- MAPPA FORNITORI -->
<div class="cointainer-fluid mb-5">
  <div class="row">
    <div class="col-12">
      <div id="map" style="width:100%; height:400px">
      </div>
    </div>
  </div>
  <!-- //MAPPA FORNITORI -->
  <!-- LISTA FORNITORI -->
  <div class="container my-5">
    <!-- PRIMA RIGA FORNITORI -->
    <div class="row fornitori mb-3">
      <div class="col-12 col-md-3 mb-5 mb-md-0" *ngFor="let installatore of installatori">
        <img *ngIf="installatore.foto" [appSrcMobileLandscape43]="installatore.foto.path" [alt]='installatore.foto.alt' class="img-fluid mx-auto d-block">
        <h6 class="text-uppercase font-weight-semi-bold my-3">{{installatore.ragioneSociale}}</h6>
        <p *ngIf="installatore.geolocalizzazione" class="">
          {{installatore.geolocalizzazione.indirizzo}}, {{installatore.geolocalizzazione.civico}}, {{installatore.geolocalizzazione.cap}} {{installatore.geolocalizzazione.citta}}</p>
        <p *ngIf="installatore.email"><span class="font-weight-semi-bold">{{'EMAIL' | translate | htmlToText}}: </span> <a href="mailto:{{installatore.email}}">{{installatore.email}}</a></p>
        <p *ngIf="installatore.telefono"><span class="font-weight-semi-bold">{{'TELEFONO' | translate | htmlToText}}: </span> <a href="tel:{{installatore.telefono}}">{{installatore.telefono}}</a></p>
        <p *ngIf="installatore.sito"><span class="font-weight-semi-bold">{{'SITO_WEB' | translate | htmlToText}}: </span> <a href="{{installatore.sito}}" target="_blank">{{installatore.sito}}</a>
        </p>
      </div>
    </div>

    <!-- //SECONDA RIGA FORNITORI -->
  </div>
  <!-- //LISTA FORNITORI -->
